<template>
  <transition name="moveing">
    <div v-show="isShowTopTitle" class="header_index_nav" 
      :class="{active_t: lockTop}">
      <div class="sticky-wrapper" style="height: auto;"></div>
      <header>
        <div class="index_nav">
          <div class="nav_box">
            <div class="nav_flex">
              <div class="nav_logo_w" @click="toMain"></div>
              <div class="nav_li">
                <div class="nav_li_text" @click="headerClick('aboutus')">关于我们</div>
                <div class="nav_li_text" @click="headerClick('society')">社会责任</div>
                <div class="nav_li_text" @click="headerClick('news')">新闻动态</div>
                <div class="nav_li_text" @click="headerClick('InvestorRelations')">投资者关系</div>
                <div class="nav_li_text" @click="headerClick('joinus')">加入我们</div>
              </div>
            </div>
          </div>
        </div>
        <!--移动端导航-->
        <div class="mobile_index_nav">
          <div class="nav_logo_w" @click="toMain"></div>
          <div :class="{ menuline: true, menulineactive: showMobileTitle }" @click="navClick">
            <div class="middleline"></div> 
          </div>
        </div>
        <transition name="mobile-nav">
          <div class="mobile_open_nav" v-show="showMobileTitle">
            <div class="m_open_logo">
              <div class="nav_logo_w"></div>
              <div :class="{ menuline: true, menulineactive: showMobileTitle }" @click="navClick">
                <div class="middleline"></div> 
              </div>
            </div>
            <div class="m_open_list" >
              <div class="m_list_text" @click="headerClick('aboutus')">关于我们</div>
              <div class="m_list_text" @click="headerClick('society')">社会责任</div>
              <div class="m_list_text" @click="headerClick('news')">新闻动态</div>
              <div class="m_list_text" @click="headerClick('InvestorRelations')">投资者关系</div>
              <div class="m_list_text" @click="headerClick('joinus')">加入我们</div>
            </div>
          </div>
        </transition>
        
      </header>
    </div>
  </transition>
  
  
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import store from '../../../store'
export default {
  name: 'navgator',
  components:{},
  // props: {
    
  // },
    props:['aa'],
  data () {
    return {
      showMobileTitle:false,
      lockTop:false,
      oldScrollTop:0,
      isShowTopTitle:true
    }
  },
  computed: {
   
    ...mapState("global", ["navigatorInfo","currentTap"]),

    

  },
  methods:{
    ...mapActions("global", ["ActionSetCurrentTap"]),
    navClick(){
      this.showMobileTitle=!this.showMobileTitle;
    },
    headerClick(pageName){
      this.showMobileTitle = false
      this.ActionSetCurrentTap(pageName);
      this.$router.push(pageName);
    },
    toMain(){
      this.ActionSetCurrentTap('');
      this.$router.push({name:'main'})
    },
    handleScroll(){
      //获取dom滚动距离
      const scrollTop = document.documentElement.scrollTop;
      //获取可视区高度
      const offsetHeight = document.documentElement.offsetHeight;
      //获取滚动条总高度
      const scrollHeight = document.documentElement.scrollHeight;
      const winHeight = document.documentElement.clientHeight;
      let scrollStep = scrollTop - this.oldScrollTop;
      this.oldScrollTop = scrollTop;
      if(scrollTop >= (winHeight - 64)){
        
        this.lockTop = true;
        if (scrollStep < 0) {
              this.isShowTopTitle = true;
          } else {
              //当点击制定功能时候 显示导航
              if(Math.round(scrollTop) == Math.round(winHeight)){
                this.isShowTopTitle = true;
              }else{
                this.isShowTopTitle = false;
              }
              
          }
      }else{
        
        this.lockTop = false;
      }
    }
    
    
  },
  watch:{
    showMobileTitle(val){
      // if(val == true){
      //   document.getElementsByTagName('html')[0].style.overflow = "hidden";
      //   document.getElementsByTagName('body')[0].style.overflow = "hidden";
      // }else{
      //   document.getElementsByTagName('html')[0].style.overflow = "";
      //   document.getElementsByTagName('body')[0].style.overflow = "";
      // }
    }
  },
  mounted(){
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
}
</script>


<style lang="less"> 
   
</style>
